export const BACKEND_ENDPOINTS: any = {

    //Авторизация
    checkLogin: {url: 'v5/auth/check-login', method: 'post'}, // Проверка наличия аккаунат
    confirmCode: {url: 'v5/auth/confirm-code/send', method: 'post'}, // Отправка кода подтверждения
    signUp: {url: 'v5/auth/reg', method: 'post'}, // Регистрация
    Login: {url: 'v5/auth/login', method: 'post'}, // Авторизация
    refreshToken: {url: 'v5/auth/token/refresh', method: 'post'}, // Обновление токена
    getAdminRules: {method: 'post', url: 'v5/auth/admin/check-login'}, // Проверка наличия аккаунта администратора
    getCustomRules: {method: 'post', url: 'v5/auth/check-login'}, // Проверка наличия аккаунат

    //Инициализация
    getCountries: {method: 'get', url: 'v4/countries'}, // Получение стран
    getDeviceId: {method: 'get', url: 'v1/auth/get-uid'}, // device-id
    getUser: {method: 'get', url: 'v5/user'}, // Детали пользователя
    changeUser: {method: 'post', url: 'v5/user'}, //Изменение пользователя

    //Компании участника
    getCompanies: {method: 'get', url: 'v5/company/member'}, // Получение компаний пользователя
    addCompany: {method: 'post', url: 'v5/company'}, // Созданий компании пользователем
    checkExistCompany: {
        method: 'get',
        url: '/v5/company/check-exists?email={email}&phone={phone}&site={site}&title={title}'
    }, // проверка на наличии компании в базе

    //Папки
    getUserDirectory: {method: 'get', url: 'v5/user/show-directory'}, // Получение папок
    addUserDirectory: {method: 'post', url: 'v5/user/show-directory'}, // Создание папки
    saveUserDirectory: {method: 'patch', url: 'v5/user/show-directory/{DirectionId}'}, //Изменение папки
    deleteUserDirectory: {method: 'delete', url: 'v5/user/show-directory/{DirectionId}'}, //Удаление папки

    getCompanyDirectory: {method: 'get', url: 'v5/company/{CompanyCode}/show-directory'}, // Получение папок
    addCompanyDirectory: {method: 'post', url: 'v5/company/{CompanyCode}/show-directory'}, // Создание папки
    saveCompanyDirectory: {method: 'patch', url: 'v5/company/{CompanyCode}/show-directory/{DirectionId}'}, //Изменение папки
    deleteCompanyDirectory: {method: 'delete', url: 'v5/company/{CompanyCode}/show-directory/{DirectionId}'}, //Удаление папки

    setExhibitionDirectory: {method: 'post', url: 'v5/user/directory/{folder}/show/{show}/show-dir-link'}, // Добавление выставки в папку
    setCompanyExhibitionDirectory: {
        method: 'post',
        url: 'v5/company/{CompanyCode}/directory/{folder}/show/{show}/show-dir-link'
    }, // Добавление выставки в папку
    delExhibitionDirectory: {method: 'delete', url: 'v5/user/directory/{folder}/show/{show}/show-dir-link'}, //Удаление выставки из папки
    delCompanyExhibitionDirectory: {
        method: 'delete',
        url: 'v5/company/{CompanyCode}/directory/{folder}/show/{show}/show-dir-link'
    }, //Удаление выставки из папки

    // Выставки
    joinUserExhibition: {method: 'post', url: 'v5/user/show/{ShowCode}/join'}, //Присоединение к выставке
    joinCompanyExhibition: {method: 'post', url: 'v5/company/{CompanyCode}/show/{ShowCode}/join'}, //Присоединение компании к выставке
    changePlan: {method: 'post', url: 'v5/show-company-participant/{id}/plan/change'}, // изменение тарифа
    getCurrentUserExhibitions: {method: 'get', url: 'v5/user/show'}, //Получение текущих выставок
    getCurrentCompanyExhibitions: {method: 'get', url: 'v5/company/{CompanyCode}/show'}, //Получение текущих выставок
    getShow: {method: 'get', url: 'v5/user/show'}, // получаем выставки
    getCompanyShowFromServer: {method: 'get', url: 'v5/company/{CompanyCode}/show'}, // получаем выставки
    addUserExhibition: {method: 'post', url: 'v5/user/show'}, // создаем выставку
    updateUserExhibition: {method: 'patch', url: 'v5/user/show/{CodeCurrentShow}'}, // обновляем выставку
    updateCompanyExhibition: {method: 'patch', url: 'v5/company/{companyCode}/show/{CodeCurrentShow}'}, // обновляем выставку
    deleteCompanyExhibition: {method: 'delete', url: 'v5/company/{companyCode}/show/{CodeCurrentShow}'}, // даляем выставку
    deleteUserExhibition: {method: 'delete', url: 'v5/user/show/{CodeCurrentShow}'}, // даляем выставку

    addCompanyExhibition: {method: 'post', url: 'v5/company/{CompanyCode}/show'}, // создаем выставку
    getSearchedUserExhibitions: {method: 'get', url: 'v5/user/show'}, // поиск по выставкам
    getSearchedCompanyExhibitions: {method: 'get', url: 'v5/company/{CompanyCode}/show'}, // поиск по выставкам
    sendSupport: {method: 'post', url: 'v5/support/appeal'}, // Создать обращение в тех. поддержку

    // Продукты
    getProducts: {method: 'get', url: 'v5/company/{CompanyCode}/show/{ShowCode}/products'}, // получение продукции
    getThematics: {method: 'get', url: 'v4/show/{ShowCode}/thematic'}, // получение разделов
    getProduct: {method: 'get', url: 'v5/company/product/{productId}'}, // получение одного продукта
    addNewProduct: {method: 'post', url: 'v5/company/{CompanyCode}/product'}, // создание продукта
    deleteProductFromServer: {method: 'delete', url: 'v5/company/product/{productId}'}, // удаление продукта
    joinProductToShow: {method: 'post', url: 'v5/company/show/{showCode}/product/{productId}/join'}, // присоединение продукта к выставке
    editProduct: {method: 'patch', url: 'v5/company/product/{productId}'}, // изменение продукта
    editProductShow: {method: 'patch', url: 'v5/company/show/show-product/{productId}'}, // изменение продукта на выставке
    exportProducts: {method: 'get', url: 'v4/svgzip/{ShowCompanyId}'}, // выгрузка продукции

    //профиль компании
    getProfileCompanyFromServer: {method: 'get', url: 'v5/company/{CompanyCode}'}, // профиль компании
    saveProfileCompanyByServer: {method: 'patch', url: 'v5/company/{CompanyCode}'}, // профиль компании
    getCompanyInfo: {method: 'get', url: 'v5/company/show/participant/{companyId}'}, // получение профиля компании в настройке выставки
    saveCompanyInfo: {method: 'patch', url: 'v5/company/show/participant/{companyId}'}, // изменение профиля компании в настройке выставки

    //Сотрудники
    getEmployeesCompanyFromServer: {method: 'get', url: 'v5/company/{CompanyCode}/member'}, // сотрудники компании
    getInviteCompanyFromServer: {method: 'get', url: 'v5/company/{CompanyCode}/phone-invite'}, // получение приглашения
    addInviteEmployeesCompany: {method: 'post', url: 'v5/company/{CompanyCode}/phone-invite'}, // создание приглашения
    refreshInviteEmployeesCompany: {method: 'post', url: 'v5/company/{CompanyCode}/phone-invite'}, // создание приглашения
    deleteInviteEmployeesCompany: {method: 'delete', url: 'v5/company/phone-invite/{memberId}'}, // удаление приглашения
    pathEmployeesCompanyFromServer: {method: 'patch', url: 'v5/company/member/{memberId}'}, // изменение сотрудника
    deleteEmployeesCompanyFromServer: {method: 'patch', url: 'v5/company/member/{memberId}'}, // изменение сотрудника
    getUserInvitesFromServer: {method: 'get', url: 'v5/user/phone-invite'}, // приглашения пользователя
    rejectInviteFromServer: {method: 'post', url: 'v5/company/{CompanyCode}/phone-invite/reject'}, // отклонение приглашения
    acceptInviteFromServer: {method: 'post', url: 'v5/user/company/{CompanyCode}/phone-invite/accept'}, // отклонение приглашения

    // Контактый блок
    fetchFieldsList: {method: 'get', url: 'v5/company/{CompanyCode}/show/{showCode}/contact-block/field/type'}, // Получение полей для дропдауна
    fetchContacts: {method: 'get', url: 'v5/company/{CompanyCode}/show/{showCode}/contact-block/field'}, // Получение сохраненных полей
    patchContacts: {method: 'patch', url: 'v5/company/{CompanyCode}/show/{showCode}/contact-block/field'}, // Сохранение полей

    // Профиль компании
    getProfileCompany: {method: 'get', url: 'v5/company/show/participant/{CompanyParticipantId}'}, // Получение
    patchProfileCompany: {method: 'patch', url: 'v5/company/show/participant/{CompanyParticipantId}'}, // Изменение

    // Профиль пользователя
    patchProfileUser: {method: 'patch', url: 'v5/user'}, // Изменение

    //Бэйджи стендистов
    getCompanyMembers: {method: 'get', url: 'v5/company/{CompanyCode}/show/{showCode}/company-member'},// Получение списка на выставке
    getCompanyMembersFromFilter: {method: 'get', url: 'v5/company/{CompanyCode}/show/{showCode}/standmen'},// Получение списка на выставке
    getCompanyMember: {method: 'get', url: 'v5/badge/{badgeId}'},// Получение одного
    addCompanyMember: {method: 'post', url: 'v5/company/{CompanyCode}/show/{showCode}/member/join'},// Получение одного
    deactivateCompanyMember: {method: 'post', url: 'v5/company/show/company-member/{badgeId}/deactivate'},// Деактивация бейджа
    patchCompanyMember: {method: 'patch', url: '/v5/company/show/company-member/badge/{badgeId}'},// редактирование бейджа

    // Анкеты
    getSurveys: {
        method: 'get',
        url: 'v5/company/{CompanyCode}/show/{showCode}/surveys?expand=questions,questionsCount,countOfShards'
    }, // Получение всех анкет
    createSurvey: {
        method: 'post',
        url: 'v5/company/{CompanyCode}/show/{showCode}/surveys?expand=questions,questionsCount,countOfShards'
    }, // Создание анкеты
    getSurvey: {method: 'get', url: 'v5/company/surveys/{surveyCode}?expand=questions,questionsCount,countOfShards'}, // Получение одной анкеты
    editSurvey: {method: 'patch', url: 'v5/company/surveys/{surveyCode}?expand=questions,questionsCount,countOfShards'}, // Редактирование анкеты

    // Статистика
    fetchTotal: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/stand/count-contact'},
    fetchCreatedContacts: {
        method: 'get',
        url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/created-contacts-surveys'
    },
    fetchShardAttributes: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/shard/attributes'},
    fetchStandmansRating: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/standman-rating'},
    fetchActiveStandmans: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/active-standman'},
    fetchSurveys: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/filled-surveys'},
    fetchStandmansContacts: {
        method: 'get',
        url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/standmans/created-contacts'
    },
    fetchStandmansSurveys: {
        method: 'get',
        url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/standmans/standmen-contact-survey'
    },
    fetchProductByThematics: {
        method: 'get',
        url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/count-scan-products-by-thematics'
    },
    fetchProductScans: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/count-scans-products'},
    scannedBadgesByProduct: {
        method: 'get',
        url: 'v5/statistic/company/show/{showCode}/product/{productId}/scanned-badges'
    },
    surveysById: {
        method: 'get',
        url: 'v5/statistic/company/surveys/{surveyId}'
    },

    // Шарды
    //Личное пространство
    getPersonalShards: {method: 'get', url: 'v5/user/show/{showCode}/shards?{query}expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb'},
    patchPersonalShards: {method: 'patch', url: 'v5/user/shards/{shardId}?expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb'},
    getPersonalShard: {method: 'get', url: 'v5/user/shards/{shardId}?expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb'},
    patchPersonalContact: {method: 'patch', url: 'v5/user/shards/contacts/{contactId}'}, // редактирование контакта
    deletePersonalContact: {method: 'delete', url: 'v5/user/shards/contacts/{contactId}'}, // редактирование контакта
    addPersonalContact: {method: 'post', url: 'v5/user/shards/{shardId}/contacts'}, // создание контакта
    patchPersonalLocation: {method: 'patch', url: 'v5/user/shards/locations/{locationId}'}, // редактирование адреса
    deletePersonalLocation: {method: 'delete', url: 'v5/user/shards/locations/{locationId}'}, // редактирование адреса
    addPersonalLocation: {method: 'post', url: 'v5/user/shards/{shardId}/locations'}, // создание адреса
    patchPersonalMedia: {method: 'post', url: 'v5/user/shard/media-attachments/{id}'}, // изменение заметки
    deletePersonalMedia: {method: 'delete', url: 'v5/user/shard/media-attachments/{id}'}, // удаление заметки
    exportAllShardsPersonal: {method: 'post', url: 'v5/user/show/{showCode}/shards/export'},
    exportOneShardsPersonal: {method: 'post', url: 'v5/user/shards/{shardId}/export'},
    addNoteCompany: {method: 'post', url: 'v5/company/{CompanyCode}/shard/{shardId}/media-attachments'},
    addNotePersonal: {method: 'post', url: 'v5/user/shard/{shardId}/media-attachments'},


    //Компания api/v5/company/{CompanyCode}/show/{showCode}/email-data/statuses/count
    getPageStatisticsSummary: {method: 'get', url: 'v5/statistic/company/{CompanyCode}/show/{showCode}/mailing'}, // параметры статичтические на странице статистики
    getStatisticsSummary: {method: 'get', url: 'v5/company/{CompanyCode}/show/{showCode}/email-data/statuses/count'}, // параметры статичтические
    getCompanyShards: {
        method: 'get',
        url: 'v5/company/{companyCode}/show/{showCode}/shards?{query}expand=emailData,dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb'
    }, // (для стендистов с параметром
    getCompanyShardsByMailing: {method: 'get', url: 'v5/company/{companyCode}/show/{showCode}/shards'}, // (для стендистов с параметром
    patchCompanyShards: {
        method: 'patch',
        url: 'v5/company/shards/{shardId}?expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb'
    }, // v5/company/{companyCode}/show/{showCode}/shards/{shardId}
    getCompanyShard: {
        method: 'get',
        url: 'v5/company/shards/{shardId}?expand=emailData,dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb'
    },
    patchCompanyContact: {method: 'patch', url: 'v5/company/{companyCode}/shards/contacts/{contactId}'}, // редактирование контакта
    deleteCompanyContact: {method: 'delete', url: 'v5/company/{companyCode}/shards/contacts/{contactId}'}, // редактирование контакта
    addCompanyContact: {method: 'post', url: 'v5/company/{companyCode}/shards/{shardId}/contacts'}, // создание контакта
    patchCompanyLocation: {method: 'patch', url: 'v5/company/{companyCode}/shards/locations/{locationId}'}, // редактирование адреса
    deleteCompanyLocation: {method: 'delete', url: 'v5/company/{companyCode}/shards/locations/{locationId}'}, // редактирование адреса
    addCompanyLocation: {method: 'post', url: 'v5/company/{companyCode}/shards/{shardId}/locations'}, // создание адреса
    patchCompanyMedia: {method: 'post', url: 'v5/company/{companyCode}/shard/media-attachments/{id}'}, // изменение заметки
    deleteCompanyMedia: {method: 'delete', url: 'v5/company/{companyCode}/shard/media-attachments/{id}'}, // удаление заметки
    getAdditionPaid: {method: 'get', url: 'v5/company/{companyCode}/show/{showCode}/plan-addition-paid'}, // удаление заметки
    getCountShards: {method: 'get', url: 'v5/company/{companyCode}/show/{showCode}/export/count'}, // получение количества шардов
    exportAllShardsCompany: {method: 'post', url: 'v5/company/{companyCode}/show/{showCode}/shards/export'},
    exportOneShardsCompany: {method: 'post', url: 'v5/company/{companyCode}/shards/{shardId}/export'},



    // Приглашение по коду
    getCodeInvite: {method: 'get', url: 'v5/company/{companyCode}/show/{showCode}/code-invite'},
    refreshCodeInvite: {method: 'post', url: '/v5/company/{companyCode}/show/{showCode}/code-invite/refresh'},
    inviteOwner: {method: 'post', url: 'v5/company/invite-owner'},

    //рассылка
    getMailConfiguration:{ // Получение конфигурации конкретной выставки
        method:'get',
        url:'v5/show-company-participant/{idPartisipation}/mail-configuration'
    },
    getImportListMailConfiguration:{ //Получение всех конфигураций
        method:'get',
        url:'v5/company/{companyCode}/mail-configuration'
    },
    getStatusMailConfiguration:{ // получение статуса конфигрурации
        method:'get',
        url:'v5/show-company-participant/{idPartisipation}/mail-configuration/connection'
    },
    sendTestEmail:{ // Отправка тестового письма
        method:'post',
        url:'v5/show-company-participant/{idPartisipation}/test-email/send'
    },
    saveMailConfiguration:{ // Сохранение конфигурации
        method:'post',
        url:'v5/show-company-participant/{idPartisipation}/mail-configuration'
    },
    pathMailConfiguration:{ // Изменение конфигурации
        method:'path',
        url:'v5/show-company-participant/mail-configuration/{idConfig}'
    },
    deleteMailConfiguration:{ // Удаление конфигурации
        method:'delete',
        url:'v5/show-company-participant/mail-configuration/{idConfig}'
    },
    statisticsSummary:{ // получение статистики
        method:'get',
        url:'v5/show-company-participant/{idPartisipation}/email-data/statistics/summary'
    },
    pathConfigMailConfiguration:{ // получение статистики
        method:'patch',
        url:'v5/show-company-participant/{idPartisipation}/conf'
    },
    postLinks:{ // получение статистики
        method:'post',
        url:'v3/media-links'
    }, // {"keys":["SBL--F5KpYxmq8E2Egiiuy_IcpU3rGXP.html"] }

    mergeContacts:{
        method:'post',
        url:'v5/shard/{idSource}/contact-block/merge'
    }

}


// url/bla/bla/{companyCode} - params
// url/bla/bla/?companyCode='123' - query:{'companyCode':'123'}
// url/bla/bla/ - body:{'companyCode':'123'} если данные в body
